export default __webpack_public_path__ + "static/media/snowbird travel insurance for canadian seniors.836ad611.jpg";